<div class="new-document-container">

    <saffron-dropzone (filesDropped)="handleFileChange($event)">
    </saffron-dropzone>

    <div class="summary">
        <p class="text-center" *ngIf="files.length === 0" [innerHTML]="empty_page_greeting"></p>

        <ul class="file-list">
            <li *ngFor="let file of files; let i = index" class="file-item">
                <div class="file-header flex-row">
                    <img src="/assets/icons/clip.svg" alt="">
                    <p>{{ file.file.name }}</p>
                </div>

                <saffron-file-types
                    [isMultipartUpload]="file.isMultipart || false"
                    (multipartChange)="setMultipartFlag(i, $event)">
                </saffron-file-types>

                <button class="remove-btn btn btn-secondary btn-small" 
                        (click)="removeFile(i)">
                    Remove
                </button>

                <!-- Status Indicator -->
                <div class="status-indicator">
                    <span *ngIf="file.status === 'pending'" class="status-icon">
                        <!-- SVG for pending (inbox icon) -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2"> <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path> <path d="M4 13h3l3 3h4l3 -3h3"></path> </svg> 
                    </span>
                    <span *ngIf="file.status === 'uploading'" class="status-icon spinning">
                        <!-- SVG for uploading -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2"> <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"></path> <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"></path> </svg> 
                    </span>
                    <span *ngIf="file.status === 'success'" class="status-icon success">
                        <!-- SVG for success (party popper) -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
                            <path d="M4 5h2"></path>
                            <path d="M5 4v2"></path>
                            <path d="M11.5 4l-.5 2"></path>
                            <path d="M18 5h2"></path>
                            <path d="M19 4v2"></path>
                            <path d="M15 9l-1 1"></path>
                            <path d="M18 13l2 -.5"></path>
                            <path d="M18 19h2"></path>
                            <path d="M19 18v2"></path>
                            <path d="M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39z"></path>
                          </svg>
                    </span>
                    <span *ngIf="file.status === 'error'" class="status-icon error">
                        <!-- SVG for error (x icon) -->
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2">
                            <path d="M12 9v4"></path>
                            <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"></path>
                            <path d="M12 16h.01"></path>
                        </svg>
                    </span>
                </div>

                <!-- Error Section -->
                <div *ngIf="file.status === 'error'" class="error-section">
                    <p class="error-message">Failed to upload: {{ file.errorMessage }}</p>
                    <button class="retry-btn btn btn-primary btn-small" (click)="retryFileUpload(i)">
                        Retry
                    </button>
                </div>
            </li>
        </ul>
    </div>

    <div class="errors text-small" *ngIf="errors.length">
        <p>Cannot submit files. Please resolve the following issues:</p>
        <br>
        <span *ngFor="let error of errors">{{ error }}<br></span>
    </div>

    <div class="footer">
        <saffron-household-picker
            [disabled]="sending"
            (householdSelected)="selectedHouseholdId = $event">
        </saffron-household-picker>
        <button *ngIf="files.length > 0"
                class="btn btn-primary"
                (click)="sendFiles()"
                [disabled]="!sendButtonEnabled()">
            {{ sending ? 'Uploading...' : 'Upload ' + (files.length == 1 ? '1 file' : files.length + ' files') }}
        </button>
    </div>

</div>
